import { BoxStaffTabDayToDay } from "@modules/boxStaff/components/boxStaffDayToDay"
import { BoxStaffTabProfile } from "@modules/boxStaff/components/boxStaffTabProfile"
import { displayIcon } from "@modules/boxStaff/entities/boxStaffUtils"
import { useBoxStaff } from "@modules/boxStaff/hooks/useBoxStaff"
import { word } from "@modules/core/utils/i18n"
import { useSidebar } from "@modules/sidebar/hooks/useSidebar"
import { HuAvatarCardSidebar } from "@modules/ui/components/huAvatarCardSidebar"
import { MenuItem } from "primereact/menuitem"
import { TabMenu } from "primereact/tabmenu"
import { useTheme } from "styled-components"

export const BoxStaffDetailsInfo: React.FC<{
  staffId: string
}> = ({ staffId }) => {
  const { data: staffDetailed, isLoading, updateBoxStaff } = useBoxStaff(staffId)
  const theme = useTheme()
  const { getCurrentStackState, setCurrentStackState } = useSidebar()

  const activeIndex = getCurrentStackState("activeTabIndex") ?? 0

  const items: MenuItem[] = [
    { label: word("box.member.detailsInfo.dayToDay") },
    { label: word("box.member.detailsInfo.profile") },
  ]

  return (
    <>
      {/* HEADER */}
      <HuAvatarCardSidebar
        id={staffDetailed?.userId}
        avatar={staffDetailed?.publicProfile?.avatar}
        firstname={staffDetailed?.firstname}
        lastname={staffDetailed?.lastname}
        username={staffDetailed?.username}
        prefixUsername={staffDetailed?.username ? "@" : undefined}
        nationality={staffDetailed?.publicProfile?.nationality}
        email={staffDetailed?.email}
        isLoading={isLoading}
        logo={displayIcon(theme.mainWhite, 50, staffDetailed?.role)}
      />
      {/* NAVIGATION TABS */}
      <div className="flex w-full mt-3">
        <TabMenu
          model={items}
          activeIndex={activeIndex}
          onTabChange={(e) => setCurrentStackState("activeTabIndex", e.index)}
          className="w-full"
        />
      </div>

      {activeIndex === 0 && (
        <BoxStaffTabDayToDay staffDetailed={staffDetailed} isLoading={isLoading} updateBoxStaff={updateBoxStaff} />
      )}
      {activeIndex === 1 && <BoxStaffTabProfile staffDetailed={staffDetailed} />}
    </>
  )
}
